import React from "react"
import Landing from '../components/Landing';

function Home() {
  return (
    <div>
      <Landing />
    </div>
  )
};

export default Home;
